const KWeeks = [
    {id: "0", value: "本周"},    
    {id: "1", value: "1周前"},
    {id: "2", value: "2周前"},
    {id: "3", value: "3周前"},
    {id: "4", value: "4周前"},
  ];  
  
  export default KWeeks  